// DuplicateWarningModal.jsx
import React, { useState } from 'react';
import { Modal, ToastContainer } from 'react-bootstrap';
import { ArrowBullet, BlueEye, CloseEye, Expand, Eye, InfoIcon } from '../../AllSvg';
import { FRONTEND_URL } from '../../../config/axios';
import { formattedDateLong } from '../../Date';

const DuplicateWarningModal = ({ applicant, duplicates }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const getStatusBadge = (status) => {
        switch (status) {
            case 'approved': return <span style={{ color: '#4CAF50', fontWeight: 'bold' }}>✓ Approved</span>;
            case 'rejected': return <span style={{ color: '#f44336', fontWeight: 'bold' }}>✗ Rejected</span>;
            case 'pending': return <span style={{ color: '#FF9800', fontWeight: 'bold' }}>⏳ Pending</span>;
            default: return status;
        }
    };

    return (
        <>
            <button
                onClick={handleShow}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    marginLeft: '5px',
                    position: 'relative'
                }}
                title={`${applicant.duplicate_count} duplicate application(s) found`}
            >
                {/* <AlertTriangle size={18} color="#f44336" /> */}
                {/* <ArrowBullet /> */}
                {/* <CloseEye /> */}
                <InfoIcon size={25} />
                {applicant.duplicate_count > 0 && (
                    <span style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-5px',
                        background: '#f44336',
                        color: 'white',
                        borderRadius: '50%',
                        width: '15px',
                        height: '15px',
                        fontSize: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {applicant.duplicate_count}
                    </span>
                )}
            </button>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Duplicate Applications Found
                        <InfoIcon size={25} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ marginBottom: '20px' }}>
                        <strong>{applicant.name}</strong> has <strong>{applicant.duplicate_count}</strong> other application(s) with the same Aadhaar number.
                    </p>

                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ background: '#f5f5f5' }}>
                                <tr>
                                    <th style={tableHeaderStyle}>Applied Date</th>
                                    <th style={tableHeaderStyle}>Name</th>
                                    <th style={tableHeaderStyle}>Email</th>
                                    <th style={tableHeaderStyle}>Department</th>
                                    <th style={tableHeaderStyle}>Position</th>
                                    <th style={tableHeaderStyle}>Company</th>
                                    <th style={tableHeaderStyle}>Resume Status</th>
                                    <th style={tableHeaderStyle}>Last Remarks</th>
                                    <th style={tableHeaderStyle}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {duplicates.map((dup, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
                                        <td style={tableCellStyle}>{dup.applied_date_formatted}</td>
                                        <td style={tableCellStyle}>{dup.name}</td>
                                        <td style={tableCellStyle}>{dup.email}</td>
                                        <td style={tableCellStyle}>{dup.department_name}</td>
                                        <td style={tableCellStyle}>{dup.position_name}</td>
                                        <td style={tableCellStyle}>{dup.sub_company_name}</td>
                                        <td style={tableCellStyle}>{getStatusBadge(dup.resume_list_status)}</td>
                                        <td style={tableCellStyle}>{dup.remarks}</td>
                                        <td style={tableCellStyle}>
                                            <a
                                                href={`${FRONTEND_URL}/applicantview/${dup.jobpost}/${dup.email}/`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <Eye size={16} color="#2576BC" />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '20px', padding: '10px', background: '#fff3e0', borderRadius: '5px' }}>
                        <strong>Current Application Details:</strong><br />
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px', marginTop: '10px' }}>
                            <div><strong>Department:</strong> {applicant.department_name}</div>
                            <div><strong>Position:</strong> {applicant.position_name}</div>
                            <div><strong>Applied:</strong> {formattedDateLong(applicant.applied_date)}</div>
                            <div><strong>Status:</strong> {getStatusBadge(applicant.resume_list_status)}</div>
                        </div>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <button onClick={handleClose} style={buttonStyle}>Close</button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};

const tableHeaderStyle = {
    padding: '10px',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '12px'
};

const tableCellStyle = {
    padding: '10px',
    fontSize: '12px'
};

const buttonStyle = {
    padding: '8px 20px',
    background: '#2576BC',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer'
};

export default DuplicateWarningModal;